<template>
  <line
    v-for="(value, index) in xAxisValues"
    :x1 = "value * getMagScale + getXAxisGap"
    :y1 = "0"
    :x2 = "value * getMagScale + getXAxisGap"
    :y2 = "yPixel"
    pointer-events = "none"
    :style = "gridlineColor"
  />
</template>

<script>
import { useInputStore } from '@/store/InputStore';
import { useSegmentStore } from '@/store/SegmentStore';

export default {
  name: 'Grid',
  props: [
      'type'
  ],
  computed: {
    gridlineColor () {
      return 'stroke:rgb(' + useSegmentStore().hexToRgb('#e5e5e5')  + ')';
    },
    height () {
      return useInputStore().getPressureFlowChartHeight;
    },
    getWidthWithOffsets () {
      const inputStore = useInputStore();
      let left = inputStore.getLeftOffset;
      let right = inputStore.getRightOffset;
      let rightPipe = useSegmentStore().getAllSegmentLengths('pipe');
      return ((rightPipe - right) - left) * this.getMagScale;
    },
    xAxisValues () {
      let width = this.getWidthWithOffsets;
      let totalVerticalLines = (width / this.getMagScale) / this.getSprinklerSpacing;
      let values = [];
      for (let a = 0; a < totalVerticalLines; a++) {
        let value = (a * this.getSprinklerSpacing) + (useInputStore().getLeftOffset);
        values.push(value);
      }
      return values;
    },
    getSprinklerSpacing () {
      return useInputStore().getSprinklerSpacing;
    },
    getMagScale () {
      return useSegmentStore().getMagScale;
    },
    getXAxisGap () {
      return useInputStore().getXAxisGap;
    },
    yPixel () {

      if(this.type === 'grid') {
        return useSegmentStore().getPipeEditorHeight;
      }

      const inputStore = useInputStore();
      const height = inputStore.getPressureFlowChartHeight;
      return height - (0.5 * (height - inputStore.getSliderGap) / inputStore.getMarginValueCount);
    },
  },
};
</script>